
export default class Mime {
    readonly type?: string;
    readonly subtype?: string;
    readonly subtypes?: Set<string>;
    readonly parameter?: { key: string, value: string };
  
    constructor(contentType: string | null) {
      if (typeof contentType !== 'string') return;
  
      const [value, parameter] = contentType.split(';');
      const [type, subtype] = value.split('/');
  
      this.type = type.toLowerCase();
      this.subtype = subtype.toLowerCase();
      this.subtypes = new Set(this.subtype.split('+'));
  
      if (parameter) {
        const [key, value] = parameter.split('=');
        this.parameter = { key, value };
      }
    }
  
    isType(type: string): boolean {
      return type.toLowerCase() === this.type;
    }
  
    isSubtype(subtype: string): boolean {
      return subtype.toLowerCase() === this.subtype;
    }
  
    hasSubtype(...subtype: string[]): boolean {
      return subtype.every(s => this.subtypes?.has(s.toLowerCase()));
    }
  }
  